//https://bezkoder.com/vue-multiple-files-upload/#Web_API_for_File_Upload_038_Storage
import axios from "axios";
import { API_HOST } from "./APointAPI";
import { __ } from "@/plugins/i18n/index";
import { errorReceived } from "@/services/apointUtil";

const http = axios.create({
  baseURL: API_HOST + "/files",
  headers: {
    "Content-type": "application/json",
  },
});

// import http from "../http-common";
import store from "../store/index";

class UploadFilesService {
  upload(file, onUploadProgress, ParentType, ParentID, OrgID, Subject, FileId) {
    // console.log("API_HOST", API_HOST);
    let formData = new FormData();

    formData.append("sessionToken", store.state.api.sessionToken);
    formData.append("CreatedBy", store.state.api.userID);
    formData.append("ParentType", ParentType);
    formData.append("ParentID", ParentID);
    formData.append("OrgID", OrgID);
    formData.append("Subject", Subject);
    formData.append("FileId", FileId);

    formData.append("file", file);
    // console.log("upload formData", formData);
    return http.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }
}
export function getPicture(SourceType,
  onSuccess = (obj) => {
    console.log("Camera cleanup success.", obj);
  },
  onFail = (message) => {
    console.log("ailed because: ", message);
  }
) {
  // console.log("init GetPicther");

  window.navigator.camera.getPicture(
    (fileURI) => {
      if (isBase64Image(fileURI))
        onSuccess("data:image/jpeg;base64," + fileURI);
      else 
      errorReceived(__("Uploading a picture"), undefined, __("Only an image type file must be selected!"));
    },
    onFail,
    {
      sourceType: SourceType,
      destinationType: window.Camera.DestinationType.DATA_URL,
      encodingType: window.navigator.camera.EncodingType.JPEG,
      mediaType: window.navigator.camera.MediaType.PICTURE,
    }
  );
  if (window.cordova.platformId === "browser") {
    const inputFile = document.querySelectorAll("input")[
      document.querySelectorAll("input").length - 1
    ];
    inputFile.style.display = "none";
    inputFile.click();
  }
}
export function isBase64Image(base64String) {
  // Remove data URL prefix if present
  const base64Data = base64String.replace(/^data:image\/(png|jpeg|jpg|gif);base64,/, '');

  // Convert base64 to bytes
  const binaryData = atob(base64Data);

  // Extract the first few bytes to check the file signature
  const signature = binaryData.substring(0, 4);

  // Check if the signature matches image file types
  return (
    signature === '\xFF\xD8\xFF\xE0' || // JPEG
    signature === '\xFF\xD8\xFF\xE1' || // JPEG
    signature === '/9j/' || // JPEG
    signature === '\x89PNG' || // PNG
    signature === 'JVBERi0='  // PNG
    // Add more signatures for other image types if needed
  );
}

export default new UploadFilesService();
